// Proxy to esbuild-compiled output
module.exports = require('./lib')
